import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserNotSupportedComponent } from './browser-not-supported.component';
import { AppRoutesName } from '../../const/AppRoutesName';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GenericAlertComponent } from '../../components/generic-alert/generic-alert.component';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.BROWSER_NOT_SUPPORTED,
    component: BrowserNotSupportedComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.BROWSER_NOT_SUPPORTED,
    component: BrowserNotSupportedComponent,
  },
];

@NgModule({
  declarations: [BrowserNotSupportedComponent],
  imports: [
    GenericAlertComponent,
    MatButtonModule,
    MatInputModule,
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    TranslateModule.forRoot(),
    MatFormFieldModule,
    MatCardModule,
  ],
  exports: [BrowserNotSupportedComponent],
  providers: [],
})
export class BrowserNotSupportedModule {}
